import { Suspense, lazy } from "react";

// The pages use the platform's own page parts (cards, pagination, dialogs),
// which themselves read this package. Loading them on demand keeps the
// package entry free of that circle, and off the first-paint bundle.
const List = lazy(() => import("./DatasetsPage").then((m) => ({ default: m.DatasetsPage })));
const One = lazy(() => import("./DatasetPage").then((m) => ({ default: m.DatasetPage })));

const DatasetRoute = (props) => (
  <Suspense fallback={null}>
    <One {...props} />
  </Suspense>
);

export const DatasetsRoute = (props) => (
  <Suspense fallback={null}>
    <List {...props} />
  </Suspense>
);

DatasetsRoute.title = "Datasets";
DatasetsRoute.path = "/datasets";
DatasetsRoute.exact = true;
DatasetsRoute.routes = () => [{ title: "Dataset", path: "/:id(\\d+)", exact: true, component: DatasetRoute }];
